(function(){
  // Scoped per ".sci-chart" instance so multiple BL Science sections on one page don't collide.
  document.querySelectorAll('.sci-chart').forEach(function(chartEl){
    var svg = chartEl.querySelector('svg.radar-svg');
    if(!svg) return;
    var cap = chartEl.querySelector('.chart-title');
    var NS = 'http://www.w3.org/2000/svg';

    var DATA = [];
    try { DATA = JSON.parse(chartEl.getAttribute('data-radar')); } catch(e) { DATA = []; }
    if(!DATA.length) return;

    var cx=240, cy=205, R=122, MAX=84, BASE=48, n=DATA.length;
    function pt(i,frac){ var a=(-90 + i*360/n)*Math.PI/180; return [cx+Math.cos(a)*R*frac, cy+Math.sin(a)*R*frac]; }
    function el(name,attrs){ var e=document.createElementNS(NS,name); for(var k in attrs){ e.setAttribute(k,attrs[k]); } return e; }
    function sc(v){ return Math.max(0.06,(v-BASE)/(MAX-BASE)); }
    function pts(frac,key){ return DATA.map(function(d,i){ var p=pt(i, key?sc(d[key]):frac); return p[0].toFixed(1)+','+p[1].toFixed(1); }).join(' '); }

    [0.25,0.5,0.75,1].forEach(function(f){ svg.appendChild(el('polygon',{points:pts(f),fill:'none',stroke:'#cdd8bb','stroke-width':'1'})); });
    DATA.forEach(function(_,i){ var p=pt(i,1); svg.appendChild(el('line',{x1:cx,y1:cy,x2:p[0].toFixed(1),y2:p[1].toFixed(1),stroke:'#cdd8bb','stroke-width':'1'})); });
    svg.appendChild(el('polygon',{points:pts(0,'d30'),fill:'rgba(154,168,154,0.16)',stroke:'#9aa89a','stroke-width':'2','stroke-dasharray':'5 4','stroke-linejoin':'round'}));
    var poly60=el('polygon',{fill:'rgba(77,118,40,0.40)',stroke:'#395619','stroke-width':'3','stroke-linejoin':'round'});
    svg.appendChild(poly60);
    var dots60=DATA.map(function(){ var c=el('circle',{r:'3.8',fill:'#395619'}); svg.appendChild(c); return c; });

    function draw(fracs){
      var arr=DATA.map(function(d,i){ return pt(i, fracs[i]); });
      poly60.setAttribute('points', arr.map(function(p){ return p[0].toFixed(1)+','+p[1].toFixed(1); }).join(' '));
      dots60.forEach(function(c,i){ c.setAttribute('cx',arr[i][0].toFixed(1)); c.setAttribute('cy',arr[i][1].toFixed(1)); c.setAttribute('opacity', fracs[i]>0.03?'1':'0'); });
    }
    var F30=DATA.map(function(d){ return sc(d.d30); }), F60=DATA.map(function(d){ return sc(d.d60); }), FZ=DATA.map(function(){ return 0; });
    function lerp(a,b,t){ return a.map(function(v,i){ return v+(b[i]-v)*t; }); }
    draw(F60);

    // animate Day 0 (center) -> 30 -> 60, hold, then shrink back to 0 for a seamless loop.
    (function(){
      if(window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches){ if(cap) cap.textContent='After 60 Days of Use'; draw(F60); return; }
      var capText = cap ? cap.textContent : null, capSwap = null;
      function setCap(txt){
        if(!cap || txt===capText) return;
        capText = txt;
        cap.style.opacity = '0';
        clearTimeout(capSwap);
        capSwap = setTimeout(function(){ cap.textContent = txt; cap.style.opacity = '1'; }, 280);
      }
      function ease(t){ return t<.5 ? 2*t*t : 1-Math.pow(-2*t+2,2)/2; }
      var Z=1800, P1=3000, P2=3000, HOLD=4400, P3=2200, t0=null, running=false;
      function frame(ts){
        if(t0==null) t0=ts;
        var e=ts-t0;
        if(e<Z){ draw(FZ); setCap('After 0 Days of Use'); }
        else if(e<Z+P1){ draw(lerp(FZ,F30,ease((e-Z)/P1))); setCap('After 30 Days of Use'); }
        else if(e<Z+P1+P2){ draw(lerp(F30,F60,ease((e-Z-P1)/P2))); setCap('After 60 Days of Use'); }
        else if(e<Z+P1+P2+HOLD){ draw(F60); setCap('After 60 Days of Use'); }
        else if(e<Z+P1+P2+HOLD+P3){ draw(lerp(F60,FZ,ease((e-Z-P1-P2-HOLD)/P3))); setCap('After 0 Days of Use'); }
        else { t0=ts; }
        requestAnimationFrame(frame);
      }
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(x){ if(x.isIntersecting && !running){ running=true; requestAnimationFrame(frame); } });
      },{threshold:.35});
      io.observe(svg);
    })();

    DATA.forEach(function(d,i){
      var p=pt(i,1.16), x=p[0], y=p[1];
      var anchor=(Math.abs(x-cx)<10)?'middle':(x>cx?'start':'end');
      var dy=(y<cy-6)?'-0.15em':(y>cy+6?'0.75em':'0.32em');
      var t=el('text',{x:x.toFixed(1),y:y.toFixed(1),'text-anchor':anchor,'class':'rlabel'}); t.setAttribute('dy',dy); t.textContent=d.label;
      svg.appendChild(t);
    });
  });
})();
